import BigNumber from 'bignumber.js';
import { openWarningNotification } from '../utils/tip.js';
import imageURL from '../assets/images/wallet/Icon.png'
export const trim = (number = 0, precision = 0) => {
    const array = number.toString().split(".");
    if (array.length === 1) return number.toString();
    if (precision === 0) return array[0].toString();

    const poppedNumber = array.pop() || "0";
    array.push(poppedNumber.substring(0, precision));
    const trimmedNumber = array.join(".");
    return trimmedNumber;
}

export function formatNum(val) {
    return val.replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
}

export function shorten(str) {
    if (str.length < 10) return str;
    return `${str.slice(0, 6)}...${str.slice(str.length - 4)}`;
}

export function shorten2(str) {
    return `${str.slice(0, 10)}...${str.slice(str.length - 6)}`;
}

export function formatCurrency(c, precision = 0) {
    return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: precision,
        minimumFractionDigits: precision,
    }).format(c);
}

export function unique(arr, u_key) {
    let map = new Map()
    arr.forEach((item, index) => {
        if (!map.has(item[u_key])) {
            map.set(item[u_key], item)
        }
    })
    return [...map.values()]
}

export function numberToHex(val, decimals) {
    var num_str = BigNumber(val).multipliedBy(BigNumber(10).pow(decimals));
    var x = new BigNumber(num_str);
    return x.toFixed();
}

export const addTokenToWallet = async (tokenAddress) => {
    if (window.ethereum) {
        try {
            await window.ethereum.request({
                method: "wallet_watchAsset",
                params: {
                    type: "ERC20",
                    options: {
                        address: tokenAddress,
                        symbol: 'alphaToken',
                        decimals: 9,
                        image: imageURL,
                    },
                },
            });
        } catch (error) {
            openWarningNotification(error.message)
        }
    }
};
export const calTime = (seconds) => {
    if (seconds !== 0 && !seconds) {
        return "";
    }
    const d = Math.floor(seconds / (3600 * 24));
    const h = Math.floor((seconds % (3600 * 24)) / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = Math.floor((seconds - 24 * 3600 * d - h * 3600 - m * 60));
    const dDisplay = d > 0 ? (d >= 10 ? d : "0" + d) : "00";
    const hDisplay = h > 0 ? (h >= 10 ? h : "0" + h) : "00";
    const mDisplay = m > 0 ? (m >= 10 ? m : "0" + m) : "00";
    const sDisplay = s > 0 ? (s >= 10 ? s : "0" + s) : "00";
    let result = { day: dDisplay, hour: hDisplay, minutes: mDisplay, seconds: sDisplay };
    return result;
}

export const addAvaxNet = async () => {
    try {
        const tx = await ethereum.request({
            method: 'wallet_addEthereumChain',
            params: [{
                chainId: '0x86',
                chainName: 'BSC',
                nativeCurrency: {
                    name: 'BNB',
                    symbol: 'BNB',
                    decimals: 18
                },
                rpcUrls: ['https://rpc.ankr.com/bsc'],
                blockExplorerUrls: ['https://bscscan.com/'],
            }],
        });
        return tx
    } catch (error) {

    }
}

export const getQueryString = (name) => {
	let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
	let r = window.location.search.substr(1).match(reg);
	if (r != null) {
			return decodeURIComponent(r[2]);
	};
	return null;
}
